import Image from './Viewer';
export default Image;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-image/src/index.js